import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";

const PatientHistoryDialog = ({ open, onClose, appointment }) => {
  const mockHistory = [
    {
      date: "2025-08-01",
      reason: "Fever",
      resolution: "Medication prescribed",
    },
    { date: "2025-06-12", reason: "Headache", resolution: "Hydration + rest" },
  ];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Patient History</DialogTitle>
      <DialogContent dividers>
        <List>
          {mockHistory.map((item, idx) => (
            <ListItem key={idx}>
              <ListItemText
                primary={`${item.date} — ${item.reason}`}
                secondary={item.resolution}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};

export default PatientHistoryDialog;
